import { routing } from "../../routing.js";
import { Query, SortOrder } from "../../types/index.js";
export function createClient(api) {
  async function list(campaignId, options) {
    const {
      limit,
      offset,
      sortOrder
    } = options;
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    return api.get(url, {
      query: {
        limit,
        offset,
        sort: SortOrder.stringify(sortOrder)
      }
    });
  }
  async function search(campaignId, options) {
    const {
      limit,
      offset,
      sortOrder,
      query
    } = options;
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    // TODO: Introduce dedicated Search POST API
    return api.get(url, {
      query: {
        query: Query.stringify(query),
        sort: SortOrder.stringify(sortOrder),
        limit,
        offset
      }
    });
  }
  async function get(campaignId, recipientId) {
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    const {
      recipient
    } = await api.get(`${url}/${recipientId}`);
    return recipient;
  }
  async function addContact(campaignId, contact) {
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    return api.post(url, {
      payload: {
        contact
      }
    });
  }
  async function addContacts(campaignId, contacts) {
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    return api.post(url, {
      payload: {
        contacts
      }
    });
  }
  async function removeRecipient(campaignId, recipientId) {
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    return api.delete(`${url}/${recipientId}`);
  }
  async function removeRecipients(campaignId, params) {
    const {
      query
    } = params || {};
    const url = routing.campaignRecipientsUrl.replace(':campaign_id', String(campaignId));
    return api.delete(url, {
      payload: {
        query
      }
    });
  }
  return {
    list,
    search,
    get,
    addContact,
    addContacts,
    removeRecipient,
    removeRecipients
  };
}